import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from './icons/Icons';
import { useLanguage } from '../LanguageContext';
export const CTA = () => {
  const {
    language
  } = useLanguage();
  return <section id="contacto" className="py-20 md:py-28 bg-brand-ivory relative" data-id="element-52">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-3xl shadow-sm border border-brand-gold/20 relative overflow-hidden" data-id="element-54">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-brand-gold/30 rounded-tl-3xl m-4" data-id="element-55"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-brand-gold/30 rounded-br-3xl m-4" data-id="element-56"></div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-charcoal mb-6" data-id="element-57">
            {language === 'es' ? 'Tu piel merece ser prioridad' : 'Your skin deserves to be a priority'}
          </h2>
          <p className="text-lg text-brand-charcoal/70 mb-10 max-w-2xl mx-auto" data-id="element-58">
            {language === 'es' ? 'Da el primer paso hacia una piel más sana, luminosa y equilibrada. Contáctame hoy para agendar tu evaluación.' : 'Take the first step towards healthier, more luminous, and balanced skin. Contact me today to schedule your evaluation.'}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto mb-12" data-id="element-59">
            <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-sm border border-brand-gold/10 hover:border-brand-gold/30 transition-colors group" data-id="element-60">
              <div className="w-12 h-12 rounded-full bg-brand-pink flex items-center justify-center text-brand-gold mb-4 group-hover:scale-110 transition-transform" data-id="element-61">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-62">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-63"></path>
                </svg>
              </div>
              <h3 className="font-medium text-brand-charcoal mb-1" data-id="element-64">
                {language === 'es' ? 'Llámanos o WhatsApp' : 'Call or WhatsApp'}
              </h3>
              <p className="text-brand-charcoal/60 text-sm" data-id="element-65">267-984-1013</p>
            </a>

            <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-sm border border-brand-gold/10 hover:border-brand-gold/30 transition-colors group" data-id="element-66">
              <div className="w-12 h-12 rounded-full bg-brand-pink flex items-center justify-center text-brand-gold mb-4 group-hover:scale-110 transition-transform" data-id="element-67">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-68">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-69"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-70"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-71"></line>
                </svg>
              </div>
              <h3 className="font-medium text-brand-charcoal mb-1" data-id="element-72">
                {language === 'es' ? 'Síguenos' : 'Follow us'}
              </h3>
              <p className="text-brand-charcoal/60 text-sm" data-id="element-73">
                @skinglowstudio22
              </p>
            </a>
          </div>

          <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-4 bg-brand-gold text-white text-lg font-medium rounded-full hover:bg-brand-bronze transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-74">
            {language === 'es' ? 'Agenda tu cita por WhatsApp' : 'Book your appointment via WhatsApp'}
          </a>
        </motion.div>
      </div>
    </section>;
};